<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8Z"
        stroke="var(--icon-color)" stroke-width="2" />
    <rect x="4" y="7" width="8" height="2" rx="0.5" fill="var(--icon-color)" />
    <path
        d="M8.5 4C8.77614 4 9 4.22386 9 4.5L9 11.5C9 11.7761 8.77614 12 8.5 12L7.5 12C7.22386 12 7 11.7761 7 11.5L7 4.5C7 4.22386 7.22386 4 7.5 4L8.5 4Z"
        fill="var(--icon-color)" />
</svg>
